import React, { FC, SVGProps } from 'react';
interface ArrowTurnLeftSolidFullProps extends SVGProps<any> {
  color: string;
}

const ArrowTurnLeft: FC<ArrowTurnLeftSolidFullProps> = ({ color, ...props }) => (
  <svg viewBox="0 0 640 640" {...props}>
    <path
      fill={color}
      d="M512 480c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-53-43-96-96-96H173.3l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 352H480c17.7 0 32 14.3 32 32v96z"
    />
  </svg>
);

export default ArrowTurnLeft;
